import React from 'react';

const MonthlyPrice = props => {

  return (
    <div className="PlanDetailMonthlyPriceContainer" style={{...props.style}} >
      <div className="PlanDetailMonthlyPrice" >
        税抜
        <span className="PlanDetailMonthlyPriceValue">
        {props.price}
        </span>        
        <span className="PlanDetailMonthlyPriceCurrency">
          円
        </span>
      </div>      
      <div className="PlanDetailMonthlyPriceTax" >
        (税込 
        <span className="PlanDetailMonthlyPriceTaxValue">
          {props.priceWithTax}
        </span>
        <span className="PlanDetailMonthlyPriceTaxCurrency">
          円)
        </span>
      </div>
    </div>
  );
};

export default MonthlyPrice;
